import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { _CashDeskAccountOffice } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../../../editor/AccountEditor";

interface Props {
    idOffice: number;
}

export const CashDeskAccountOffice = ({ idOffice }: Props) => {

    const cashoffice = useDataBean(_CashDeskAccountOffice);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRole, setModalRole] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalCajas, setModalCajas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idOffice, paginador.page])

    const getLista = () => {

        cashoffice.instance.getCashDeskAccountCatalog(idOffice, Account).then(
            (resp: any) => {
                if (resp) {

                    setLista(resp)
                }
            }
        )

    }
    const create = () => {
        cashoffice.setBean({
            IDOffice: idOffice
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        // cashoffice.instance.deleteOffice(cashoffice.bean.IDOffice).then(
        //     (resp: any) => {
        //         getLista();
        //         setModalC({ ...modalC, "view": false });
        //     }
        // )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        cashoffice.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID Caja', property: 'IDCashDeskAccount', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta Débito', property: 'AccountantIDName', visible: true },
        { title: 'JsconCode', property: 'JsconCode', visible: true },
        { title: 'Responsable de la Caja', property: 'AccountName', visible: true },
        { title: 'Valor de la Base', property: 'BaseValue', visible: true },
        { title: 'Caja Destino', property: 'DestinityCash', visible: true },
        { title: 'Utiliza Presupuesto', property: 'UseBudget', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Oficina a la que pertenece', property: 'OfficeName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Cuenta Contable Anticipo a Terceros', property: 'ThirdAdvanceAccountantIDStrName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (

        <div className="row">
            <div className="col-md-12">
                <label>Cajas/POS de la Oficina</label>
            </div>
            <div className="col-md-6">
                <AccountEditor label="Responsable de Caja" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} />
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={cashoffice.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">


                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {cashoffice.bean.Name}</strong>
                </ModalConfirm>
            </div>
        </div>

    )
}